export const businessChannels = [
  '国内外贸公司', '跨境卖家', '中小实体店', '零售卖家', '国内直播渠道',
  '国外社媒渠道', '传统线上c端卖家', '连锁超市', '国外贸易公司', '国外品牌商', '其他',
];

export const customerSources = [
  '1688店铺', '客户转介绍', '国内展会', '香港展会', '实体店', 'chinagoods',
  '义乌购', 'whatsapp', 'facebook', 'instagram', '独立站', '其他渠道',
];

export function normalizeCustomerSource(value?: string | null): string {
  const source = value?.trim() || '';
  const aliases: Record<string, string> = {
    '1688': '1688店铺', '1688 店铺': '1688店铺', '其他': '其他渠道',
    whatsapp: 'whatsapp', facebook: 'facebook', instagram: 'instagram', instgram: 'instagram', chinagoods: 'chinagoods',
  };
  return aliases[source.toLocaleLowerCase()] ?? source;
}

export function customerBusinessChannels(customer?: { businessChannels?: unknown; businessChannel?: string | null }): string[] {
  const values = customer?.businessChannels != null
    ? Array.isArray(customer.businessChannels) ? customer.businessChannels : []
    : typeof customer?.businessChannel === 'string' ? [customer.businessChannel] : [];
  return [...new Set(values.filter((value): value is string => typeof value === 'string').map(value => value.trim()).filter(Boolean))];
}

